import { BaseState } from '@/store/base-state';
import { Repairs } from '../../../types';
import { default_new_repair } from '../../../services';

export default class RepairInfoState extends BaseState {
 new_repair: Repairs.NewRepair = default_new_repair();
 new_repair_components: Repairs.ComponentPayload[] = [];
 new_repair_categories: Repairs.Category[] = [];
 new_repair_operation_types: Repairs.OperationType[] = [];
 new_repair_warranty_info: Repairs.Warranty[] = [];
 new_repair_actual_extended_warranties: Repairs.ExtendedWarranty[] = [];
 is_not_warranty_repair = false;
 is_not_found = false;
 search_key = 0;
 is_submitted = false;
}
